import React, { ReactElement } from 'react';

import { Play } from '@yandex-360/iconostasis/dist/icons/Play';
import { Stop } from '@yandex-360/iconostasis/dist/icons/Stop';
import { States } from '@yandex-360/telemost-sdk/audio-diagnostics';

export const getOutputDiagnosticBtnIcon = (state: States, isHovered = true): ReactElement | undefined => {
    switch (state) {
        case States.IDLE:
            return <Play variant="solid" size="sm" />;
        case States.PLAYING:
            return isHovered ? <Stop variant="solid" size="sm" /> : undefined;
        default:
            return undefined;
    }
};
